/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
==========================================================================================*/

import jwt from "../../http/requests/auth/jwt/index.js";

import bcrypt from "bcryptjs";

import firebase from "firebase/app";
import "firebase/auth";
import router from "@/router";
import store from "@/store/store.js";

import vm from '../../main.js'
import pouch from '@/db/pouch';

export default {
  login({
    commit
  }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        return await pouch.en(payload.u).then(async (eu) => {
          return await pouch.f({
            selector: {
              f: eu.a,
              z: 0
            }
          }, true, true).then(async (sr) => {
            if (sr.hasOwnProperty('f')) {
              var du = sr;
              if (du.s === true) {
                return reject("You have been suspended from accessing this system. Please contact your supervisor.");
              } else {
                var v = bcrypt.compareSync(
                  payload.u.b,
                  du.c
                );
                if (!v) {
                  return reject("Invalid Password");
                } else {
                  localStorage.setItem(
                    "remember_me",
                    payload.remember_me
                  );
                  if (payload.remember_me) {
                    localStorage.setItem(
                      "u",
                      btoa(payload.u.a)
                    );
                  } else {
                    localStorage.removeItem("u");
                  }
                  localStorage.setItem('loggedin', true);
                  delete du.c;
                  vm.$acl.change(du.e);
                  vm.$session.start();
                  vm.$session.set('user', du);
                  router.push(router.currentRoute.query.to || "/");
                  return resolve('Login Successful');
                }
              }
            } else {
              return reject("User not found");
            }


          })
        });
      } catch (e) {
        return reject(e);
      }
    });

    return vm.$pouch.find({
      selector: {
        username: payload.userDetails.username.toLowerCase()
      }
    }, "express").then((search) => {
      if (search.docs.length === 0) {
        return reject("User not found");
      } else {
        var user = search.docs[0];
        if (user.active === false) {
          return reject("You have been suspended from accessing this system. Please contact your supervisor.");
        } else {
          var validate = bcrypt.compareSync(
            payload.userDetails.password,
            user.password
          );
          if (!validate) {
            return reject("Invalid Password");
          } else {
            localStorage.setItem(
              "remember_me",
              payload.remember_me
            );
            if (payload.remember_me) {
              localStorage.setItem(
                "username",
                payload.userDetails.username
              );
            } else {
              localStorage.removeItem("username");
            }
            localStorage.setItem('loggedin', true);
            delete user.password;
            vm.$acl.change(user.role);
            vm.$session.start();
            vm.$session.set('user', user);
            router.push(router.currentRoute.query.to || "/");
            return resolve('Login Successful');
          }
        }
      }
    }).catch((err) => reject(err));

  },
};